<div
	class="input-trigger-wrapper"
	[class.focused]="focused"
	[class.has-value]="!!value"
	(click)="focused = true"
>
	<p class="placeholder-label">{{ label }}</p>
	<div class="select-trigger">
		<!--TODO Placeholder is not shown until focused, deal with placeholder without label case-->
		@if (!value) {
			<span class="placeholder">{{ placeholder }}</span>
		}

		@if (value) {
			<span class="value">
				{{ chooseRightName() }}
			</span>
		}

		@if (loading) {
			<mat-spinner diameter="20"></mat-spinner>
		}

		<span class="suffix">
			<mat-icon class="accent-icon">arrow_drop_down</mat-icon>
		</span>
	</div>
	<span class="underline">
		<span class="ripple"></span>
	</span>
</div>
